'use strict';

define(
    'BetSlipWindow',[
        'BetSlipWindowCtrl',
        'BetSlipWindowDir',
        'TrackSelectorWindowCtrl',
        'TrackSelectorWindowDir',
        'BetSlipAccountInfoDir',
        'BetSlipAccountInfoCtrl',
        'BetSlipAlertBannerDir',
        'BetSlipWindowAlertsFac',
        'Track',
        'GTMMod'
    ],

    function (BetSlipWindowCtrl,
              BetSlipWindowDir,
              TrackSelectorWindowCtrl,
              TrackSelectorWindowDir,
              BetSlipAccountInfoDir,
              BetSlipAccountInfoCtrl,
              BetSlipAlertBannerDir,
              BetSlipWindowAlertsFac) {

        angular.module('TVG.BetSlipWindow', [
            'TVG.Track',
            'TVG.Common.GTM'
        ])
            .controller('BetSlipWindowCtrl', BetSlipWindowCtrl)
            .controller('TrackSelectorWindowCtrl', TrackSelectorWindowCtrl)
            .controller('BetSlipAccountInfoCtrl', BetSlipAccountInfoCtrl)
            .factory('betSlipWindowAlertsFac', BetSlipWindowAlertsFac)
            .directive('betslipAccountInfo', BetSlipAccountInfoDir)
            .directive('trackSelectorWindow', TrackSelectorWindowDir)
            .directive('betslipWindow', BetSlipWindowDir)
            .directive('betslipAlertBanner', BetSlipAlertBannerDir);
    }
);

